import { Flex, FlexProps } from '@chakra-ui/react';
import { ProductDetailsTabs } from './components/ProductDetailsTabs';

const ProductDetailsData = (props: FlexProps): JSX.Element => (
  <Flex
    direction="column"
    w="100%"
    borderRadius={8}
    bg="white"
    p="8"
    {...props}
  >
    <ProductDetailsTabs />
  </Flex>
);

export default ProductDetailsData;
